export interface IMInfoKey {
  name: string;
  key: string;
}

export interface IMPageResult {
  name?: string;
  pageNumber?: number;
  index?: number;
  children?: IMPageResult[];
  suffix?: string;
  prefix?: string;
}

export interface IMOption {
  title: string;
  children: IMOptionItem[];
}

export interface IMOptionItem {
  name: string;
  shortcut: string;
}

export enum IETreeExpand {
  'close' = 'close',
  'open' = 'open',
  'normal' = 'normal'
}
